/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {FormLabel} from 'react-bootstrap';
import {useGenericModelHooks, useShouldEditField} from "../../../Hooks/GenericModelHooks";
import {useFieldComponentRenderer} from "../../../Hooks/FieldComponentHooks";
import {Conditional} from "../../Conditional";

export const CompactModelViewerRecordRenderer = (props) => {

    const {
        getFieldDefs,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const editMode = shouldEditField(props);
    const fieldComponentRenderer = useFieldComponentRenderer(props);

    const {
        FieldDef: fieldDef,
        FieldDefinitionGroups = null,
        IsNewModel,
        OnValidationUpdate,
        RootData,
        SkipBorder,
        Validation,
        CustomData,
        DefaultSelectedFieldDefKey,
        subText = null,
    } = props;

    const fieldDefs = FieldDefinitionGroups ?? getFieldDefs?.(true);

    const fieldComponentName = editMode ? fieldDef.editor : fieldDef.viewer;
    const FieldComponent = fieldComponentRenderer(fieldComponentName, fieldDef, null, null, fieldDefs);

    if (FieldComponent == null) {
        return null;
    }

    return <div className={"sb-compact-field sb-editor-row-" + fieldDef.key}>
        <Conditional Condition={fieldDef.displayLabel}>
            <FormLabel>{fieldDef.title}</FormLabel>
        </Conditional>
        <div className={["sb-model-viewer-column", Validation?.className].join(' ')}>
            {FieldComponent}
            <Conditional Condition={subText != null}>
                <span className="sb-sub-text">Instead of: {subText}</span>
            </Conditional>
            <div className="sb-model-viewer-validation-failure-text-small" id={Validation?.id}>
                {Validation?.message ? Validation?.message : <span>&nbsp;</span>}
            </div>
        </div>
    </div>;
};
